import * as Yup from 'yup';

export const changePasswordSchema = () => {
    return (
        Yup.object({
            oldPassword: Yup.string()
                .trim()
                .required('Old password is required'),
            newPassword: Yup.string()
                .trim()
                .required('New password is required')
                .min(8, 'Password must be at least 8 characters long')
                .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
                .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
                .matches(/\d/, 'Password must contain at least one number')
                .matches(/[^a-zA-Z0-9]/, 'Password must contain at least one special character (e.g., !, @, #, $)'),
            confirmPassword: Yup.string()
                .trim()
                .required('Confirm password is required')
                .oneOf([Yup.ref('newPassword')], 'New & Confirm Passwords must match')
        }));
}
